module.exports = __webpack_public_path__ + "static/media/about_us_icon.2ff04e64.svg";